import * as React from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { clientEndpoint } from "../../../../routes/endpoint";

/**
 * 多要素認証の有効期限切れ
 * - トークンは画面遷移時にのみ渡されるため、リロードや有効期限（10分）切れの場合はログインからやり直す
 */
export const MFAExpiredPage = React.memo(() => {
	const navigate = useNavigate();
	const onLogin = React.useCallback(() => navigate(clientEndpoint.login, { replace: true }), [navigate]);
	return (
		<Card className="border-0 mx-auto my-5" style={{ maxWidth: "540px" }}>
			<Card.Body>
				<Alert variant={"warning"}>認証の有効期限が切れました。お手数ですが、ログインからやり直してください。</Alert>
				<Button className="w-100" variant={"dark"} onClick={onLogin}>
					ログインページへ
				</Button>
			</Card.Body>
		</Card>
	);
});
